import React from 'react';
import { useAppState } from '../../../client/providers/AppProvider';
import { FeatureListItem } from '../../journey/FeatureListItem';
import { PricingOption } from '../../journey/PricingOption';
import { MobileFeatureListItem } from '../../journey/MobileFeatureListItem';
import { CollegeReferralCode } from './CollegeReferralCode';
import { LimitedTimeOffer } from './LimitedTimeOffer';
import { Espin_Paid_Product_Enum } from 'generated/spin-graphql';
import {
    CollegeSubscriptionFeatureList,
    CollegeSubscriptionFeatureListForDashboard,
} from '../../../shared/shared.constants';

type Props = {};

export const CollegeSubscriptions: React.FC<Props> = () => {
    const { user, subscribed } = useAppState();

    const manualSub = user?.college_profile?.college?.manual_subtier > 0 ?? false;
    const isPremium = subscribed || manualSub;

    return (
        <div className="subscriptions">
            <div className="container">
                {!!user?.college_profile?.college?.subscription?.referral_code_redemption_id && <LimitedTimeOffer />}
                <div className="pricing-options college">
                    <div className="title-container">
                        <h2 className="title">Simple Pricing</h2>
                        {!subscribed && <CollegeReferralCode />}
                    </div>
                    <div className="pricing-options-container college">
                        <PricingOption
                            className="college"
                            monthly={false}
                            label={'Silver'}
                            value={'FREE'}
                            currentPlan={true}
                            ctaLabel={
                                !isPremium
                                    ? 'Current Plan'
                                    : `Included in ${user.subscription_status.tierlookup === 1 ? 'Gold' : ''}${
                                          user.subscription_status.tierlookup === 2 ? 'Platinum' : ''
                                      }${user.subscription_status.tierlookup === 3 ? 'Diamond' : ''}`
                            }
                            hasInterval={false}
                        />
                        <PricingOption
                            className="blue-background college"
                            monthly={false}
                            label={'Gold'}
                            value={'$500'}
                            currentPlan={((): boolean => {
                                if (user.subscription_status.tierlookup >= 1) return true;
                                return false;
                            })()}
                            subscriptionTier={Espin_Paid_Product_Enum.TierOneCollegeYearlyPlan}
                            ctaLabel={
                                user.subscription_status.tierlookup === 1
                                    ? 'Current Plan'
                                    : user.subscription_status.tierlookup >= 2
                                    ? `Included in ${user.subscription_status.tierlookup === 2 ? 'Platinum' : ''}${
                                          user.subscription_status.tierlookup === 3 ? 'Diamond' : ''
                                      }`
                                    : 'Upgrade'
                            }
                            cardHighlightText="Most Popular"
                        />
                        <PricingOption
                            className="green-background college"
                            monthly={false}
                            label={'Platinum'}
                            value={'$2,000'}
                            currentPlan={((): boolean => {
                                if (user.subscription_status.tierlookup >= 1) return true;
                                return false;
                            })()}
                            subscriptionTier={Espin_Paid_Product_Enum.TierTwoCollegeYearlyPlan}
                            ctaLabel={
                                user.subscription_status.tierlookup === 2
                                    ? 'Current Plan'
                                    : user.subscription_status.tierlookup === 3
                                    ? 'Included in Diamond'
                                    : 'Upgrade'
                            }
                        />
                        <PricingOption
                            className="purple-background custom college"
                            monthly={false}
                            label={'Diamond'}
                            value={'Custom Pricing'}
                            currentPlan={((): boolean => {
                                if (user.subscription_status.tierlookup >= 1) return true;
                                return false;
                            })()}
                            subscriptionTier={Espin_Paid_Product_Enum.TierThreeCollegeYearlyPlan}
                            contactUsEnabled={user.subscription_status.tierlookup < 3}
                            hasInterval={false}
                            ctaLabel={((): string => {
                                if (user.subscription_status.tierlookup === 3) return 'Current Plan';
                                return 'Contact Us';
                            })()}
                        />
                    </div>
                </div>
                {isPremium && !manualSub && (
                    <div className="cancel-container">
                        <form action="/api/payments/create-portal-session" method="POST" className="cancel-form">
                            <input type="hidden" name="email" value={user?.email} />
                            <button className="cancel-subscription">Manage Subscription</button>
                        </form>
                    </div>
                )}
                <div className="pricing-feature-comparison">
                    <div className="feature-header college">
                        <div className="header-title">Feature</div>
                        <div className="header-title">{isPremium ? 'Silver' : 'Current Plan'}</div>
                        <div className="header-title">
                            {user.subscription_status.tierlookup === 1 ? 'Current Plan' : 'Gold'}
                        </div>
                        <div className="header-title">
                            {user.subscription_status.tierlookup === 2 ? 'Current Plan' : 'Platinum'}
                        </div>
                        <div className="header-title">
                            {user.subscription_status.tierlookup === 3 ? 'Current Plan' : 'Diamond'}
                        </div>
                    </div>
                    <div className="feature-group college">
                        {CollegeSubscriptionFeatureList.map((feature, index) => (
                            <FeatureListItem key={`feature-list-item-${index}`} feature={feature} />
                        ))}
                    </div>
                    <div className="feature-group-mobile college">
                        {CollegeSubscriptionFeatureList.map((feature, index) => (
                            <MobileFeatureListItem key={`feature-list-item-${index}`} feature={feature} />
                        ))}
                    </div>
                    <div className="feature-group college">
                        {CollegeSubscriptionFeatureListForDashboard.map((feature, index) => (
                            <FeatureListItem key={`dashboard-feature-list-item-${index}`} feature={feature} />
                        ))}
                    </div>
                    <div className="feature-group-mobile college">
                        {CollegeSubscriptionFeatureListForDashboard.map((feature, index) => (
                            <MobileFeatureListItem key={`feature-list-item-${index}`} feature={feature} />
                        ))}
                    </div>
                </div>
                <div className="questions-container">
                    <h2 className="questions-title">Got Questions? Get Answers.</h2>
                    <a href="mailto:info@staypluggedin.com" className="button large-button blue-button">
                        Contact Us
                    </a>
                </div>
            </div>
        </div>
    );
};
